module.exports = __webpack_public_path__ + "img/Tool-shape-filled.99173cc5.svg";